import PromotionsList from './PromotionsList';
import PromotionsCreate from './promotionsCreate';
import PromotionsEdit from './promotionsEdit';
import PromotionsShow from './promotionsShow';

export default {
    list: PromotionsList,
    create: PromotionsCreate,
    edit: PromotionsEdit,
    show: PromotionsShow
}